import React from 'react';
import PropTypes from 'prop-types';
import { iconGray } from '../../theme';

const Calculator = ({ width, height, color }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 26.37 34"
  >
    <defs>
      <clipPath id="clip-path">
        <rect width={width} height={height} fill={color} />
      </clipPath>
    </defs>
    <g transform="translate(0 0)">
      <g transform="translate(0 0)" clipPath="url(#clip-path)">
        <path
          d="M21.447,34H4.923A4.928,4.928,0,0,1,0,29.077V4.923A4.928,4.928,0,0,1,4.923,0H21.447a4.929,4.929,0,0,1,4.923,4.923V29.077A4.929,4.929,0,0,1,21.447,34M4.923,2.223a2.7,2.7,0,0,0-2.7,2.7V29.077a2.7,2.7,0,0,0,2.7,2.7H21.447a2.7,2.7,0,0,0,2.7-2.7V4.923a2.7,2.7,0,0,0-2.7-2.7Z"
          transform="translate(0 0)"
          fill={color}
        />
        <path
          d="M21.447,11.843H4.923A4.928,4.928,0,0,1,0,6.92v-2A4.928,4.928,0,0,1,4.923,0H21.447a4.929,4.929,0,0,1,4.923,4.923v2a4.929,4.929,0,0,1-4.923,4.923M4.923,2.223a2.7,2.7,0,0,0-2.7,2.7v2a2.7,2.7,0,0,0,2.7,2.7H21.447a2.7,2.7,0,0,0,2.7-2.7v-2a2.7,2.7,0,0,0-2.7-2.7Z"
          transform="translate(0 0)"
          fill={color}
        />
        <path
          d="M10.9,21.83a2.213,2.213,0,1,1-2.213-2.213A2.213,2.213,0,0,1,10.9,21.83"
          transform="translate(-1.956 -5.929)"
          fill={color}
        />
        <path
          d="M20.151,21.83a2.213,2.213,0,1,1-2.213-2.213,2.213,2.213,0,0,1,2.213,2.213"
          transform="translate(-4.753 -5.929)"
          fill={color}
        />
        <path
          d="M29.4,21.83a2.213,2.213,0,1,1-2.213-2.213A2.213,2.213,0,0,1,29.4,21.83"
          transform="translate(-7.549 -5.929)"
          fill={color}
        />
        <path
          d="M10.9,30.314A2.213,2.213,0,1,1,8.686,28.1,2.213,2.213,0,0,1,10.9,30.314"
          transform="translate(-1.956 -8.494)"
          fill={color}
        />
        <path
          d="M20.151,30.314A2.213,2.213,0,1,1,17.938,28.1a2.213,2.213,0,0,1,2.213,2.213"
          transform="translate(-4.753 -8.494)"
          fill={color}
        />
        <path
          d="M29.4,30.314A2.213,2.213,0,1,1,27.19,28.1,2.213,2.213,0,0,1,29.4,30.314"
          transform="translate(-7.549 -8.494)"
          fill={color}
        />
        <path
          d="M29.4,38.8a2.213,2.213,0,1,1-2.213-2.213A2.213,2.213,0,0,1,29.4,38.8"
          transform="translate(-7.549 -11.058)"
          fill={color}
        />
        <path
          d="M15.142,41.011H8.686a2.213,2.213,0,1,1,0-4.426h6.456a2.213,2.213,0,0,1,0,4.426"
          transform="translate(-1.956 -11.058)"
          fill={color}
        />
      </g>
    </g>
  </svg>
);

Calculator.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  color: PropTypes.string,
};

Calculator.defaultProps = {
  width: 26.37,
  height: 34,
  color: iconGray,
};

export default Calculator;
